import { createContext } from "react";
import { DashboardDateRange } from "./dashboardDateRange.type";

const initialState: DashboardDateRange = {
  startDate: null,
  endDate: null,
  setDateRange: () => {}
};

export const dashboardDateRangeContext = createContext<DashboardDateRange>(initialState);

export const DashboardDateRangeContextProvider = dashboardDateRangeContext.Provider;
